module.exports = __webpack_public_path__ + "img/appAsset-brand--plemsi.21d292e8.svg";